import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export class ReporteDespachoChart extends Component {
    constructor(props) {
        super(props);
        const destinos = props.data.reduce((destinos, item) => {
            const destino = (destinos[item.destino] || []);
            destino.push(item);
            destinos[item.destino] = destino;
            return destinos;
        }, {});
        const categories = Object.keys(destinos);
        var series = [];
        for (let i = 0; i < categories.length; i++) {
            series.push(destinos[categories[i]].map((item) => item.contenedor)
                .filter((value, index, self) => self.indexOf(value) === index).length)
        }

        console.log("series", series);
        this.state = {

            series: [{
                data: series
            }],
            options: {
                chart: {
                    type: 'bar',
                    height: 400
                },
                plotOptions: {
                    bar: {
                        distributed: true, // this line is mandatory
                        borderRadius: 4,
                        horizontal: false,
                        columnWidth: '50%',
                    }
                },
                //colors: ["#2D6A4F", "#1B4332", "#FEFAE0", "#DDA15E", "#BC6C25", "#A24936"],
                colors: ["#264653", "#2a9d8f", "#e9c46a", "#f4a261", "#e76f51", "#90be6d", "#277da1", "#219ebc"],
                fill: { opacity: 1},
                dataLabels: {
                    enabled: true,
                },
                xaxis: {
                    categories: categories,
                    title: {
                        text: 'Destinos',
                        style: {
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                        }
                    },
                },
                yaxis: [{
                    title: {
                        text: 'Cantidad de contenedores',
                        style: {
                            fontFamily: 'inherit',
                            fontWeight: 'bold',
                        }
                    },

                }],
                //title: {
                //    text: 'Contenedores por destino',
                //    floating: true,
                //    //offsetY: 330,
                //    align: 'left',
                //    style: {
                //        fontFamily: 'inherit',
                //        fontWeight: 'inherit',
                //        fontSize: '18px'
                //    }
                //}
            },


        };
    }

    render() {
        return (



            <div id="chart" className="">
                <h3 className="ms-2">Contenedores por destino</h3>
                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={430} />
            </div>



        );
    }
}
